import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { removeAccessToken, removeRefreshToken } from "../../storage/storage";

const Page = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isCleaner, setIsCleaner] = useState(null);
  const navigate = useNavigate();

  const verifyUser = async () => {
    if (!id) return;
    setLoading(true);

    try {
      // CLEAR ALL EXISTING SESSIONS BEFORE VERIFICATION
      removeAccessToken();
      removeRefreshToken();
      
      // Also clear any other stored data
      sessionStorage.clear();
      localStorage.removeItem("currentUser");

      const response = await axios.get(`${BASE_URL}/api/verify-email/${id}/`);
      setMessage(response.data.message || "Verification successful!");
      
      if (!response.data.user?.is_cleaner) {
        Swal.fire({
          icon: "success",
          title: response.data.message || "Verification successful!",
          showConfirmButton: true,
          confirmButtonText: "Go to Login",
          position: "center",
          width: "90%",
          padding: "1rem",
          customClass: {
            confirmButton: "swal-responsive-button",
            popup: "swal-responsive-popup"
          },
          buttonsStyling: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/login");
          }
        });
      }
      setIsCleaner(response.data.user?.is_cleaner);
    } catch (error) {
      setMessage(error.response?.data?.message || "Verification failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center w-full h-[100vh]">
      {!isCleaner === true && (
        <div className="bg-[#FFF5CE] flex flex-col items-center justify-center px-10 py-20 rounded-lg shadow-md">
          <img className=" w-[100px] " src="/images/main-logo-2.png" alt="" />
          <h1 className="text-3xl font-bold mb-6">
            You're Almost There! Verify Your Account to Continue
          </h1>
          <button
            disabled={loading}
            onClick={verifyUser}
            className="w-[300px] h-[50px] bg-[#586989] text-white p-2 rounded font-medium mt-5"
          >
            {loading ? "Verifying..." : "Verify your account"}
          </button>
          <p className="mt-4">{message}</p>
        </div>
      )}

      {isCleaner === true && (
        <div className="bg-[#FFF5CE] flex flex-col items-center justify-center px-10 py-20 rounded-lg shadow-md">
          <p className="mt-2 font-medium">
            Email verified! You can return to your app now.
          </p>
        </div>
      )}
    </div>
  );
};

export default Page;